import { Helmet } from 'react-helmet'
import { ParallaxProvider } from 'react-scroll-parallax'
import '../../styles/Home/Home.css'
import HomeInfo from './HomeInfo'
import HomeGoal from './HomeGoal'
import HomeCounter from './HomeCounter'
import HomeActuality from './HomeActuality'
import HomeHeader from './HomeHeader'

function Home() {

    return (

        <>
            <Helmet>
                <meta name="title" content="Accueil - Vietnamensemble" />
                <meta name="description" content="Association Vietnamensemble, aide humanitaire au Vietnam" />
                <meta property="og:title" content="Accueil - Vietnamensemble" />
                <meta property="og:description" content="Association Vietnamensemble, aide humanitaire au Vietnam" />
                <meta property="og:url" content="https://www.vietnamensemble.org" />
                <link rel="canonical" href="https://www.vietnamensemble.org" />
            </Helmet>
            <ParallaxProvider>
                <div className='home'>
                    <HomeHeader />
                    <HomeInfo />
                    <HomeGoal />
                    <HomeCounter />
                    <HomeActuality />
                </div>
            </ParallaxProvider>
        </>

    )

}

export default Home
